/**
 * @generated SignedSource<<16829375031e55c65a5a2c54581d29e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCallDealerCta_item$data = {
  readonly serviceId: string | null;
  readonly seller: {
    readonly trackedPhone: {
      readonly phoneNumber: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "PdpSharedCallDealerCta_item";
};
export type PdpSharedCallDealerCta_item$key = {
  readonly " $data"?: PdpSharedCallDealerCta_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCallDealerCta_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCallDealerCta_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Phone",
          "kind": "LinkedField",
          "name": "trackedPhone",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phoneNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3be1cbd16f2f51c77e15b7cebef6cb63";

export default node;
